/*
 *  Author: DL
 *  Date: 2020-12-04 14:47:00
 *  Email: dunaliang@fengmap.com
 *  LastEditTime: 2020-12-04 14:47:42
 *  LastEditors: DL
 *  Description:
 *  Copyright: Copyright 2014 - 2020, FengMap, Ltd. All rights reserved.
 */

export default function(props) {
  return <div className={'controlWrapper'}>{props.children}</div>;
}
